import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { TABLE_HEAD_SORT_ICON_SIZE, TABLE_HEAD_SORT_FLEX_GAP } from '../../TableHeaderText/styled';
import { tableCellStyles } from '../styled';
export const StyledTableBodyCell = styled.td `
  ${tableCellStyles};

  height: var(--table-body-cell-height);
  line-height: 1;
  min-width: ${({ $loading }) => $loading && '100%'};
  max-width: ${({ $maxWidth }) => ($maxWidth ? pxToRem($maxWidth) : '100%')};
  border-top: solid ${pxToRem(1)} var(--table-border-color);
`;
export const TableCellContent = styled.div `
  display: inline-block;
  max-width: 100%;
  min-width: ${({ $initialLoading }) => $initialLoading && '100%'};
  padding-right: ${({ $removeExtraPadding }) => $removeExtraPadding ? 0 : `calc(${TABLE_HEAD_SORT_ICON_SIZE} + ${TABLE_HEAD_SORT_FLEX_GAP})`};
`;
